/**
 * Liste des fuseaux IANA proposée par le navigateur.
 *
 * `Intl.supportedValuesOf` évite d'embarquer — et de maintenir — une liste de
 * plusieurs centaines d'entrées qui vieillirait à chaque révision de la base
 * tzdata. Elle n'existe pas partout : le repli garde au moins le fuseau courant,
 * pour qu'un `<select>` ne s'affiche jamais vide sur le réglage en vigueur.
 *
 * Le fuseau du compte est toujours inclus, même absent de la liste : le serveur
 * peut connaître un fuseau que ce navigateur ignore, et l'omettre ferait
 * afficher au `<select>` une valeur qui n'est pas celle enregistrée — donc
 * changer le réglage au premier enregistrement, sans que rien ne le demande.
 */
export function timeZones(current: string): string[] {
  const supported = readSupportedTimeZones();
  return supported.includes(current) ? supported : [current, ...supported];
}

function readSupportedTimeZones(): string[] {
  const supportedValuesOf = Intl.supportedValuesOf as ((key: "timeZone") => string[]) | undefined;
  if (supportedValuesOf === undefined) {
    return [];
  }
  try {
    return supportedValuesOf("timeZone");
  } catch {
    return [];
  }
}
